import React from "react";
import Sidebar from "../components/sidebar/sidebar";
import Footer from "../components/footer/footer";
import Navbar from "../components/navbar/navbar";
import EditProfile from "../components/EditProfile/EditProfile"
import DashboardTobbar from "../components/DashboardTobbar/DashboardTobbar";

const AllProfilePage = () => {
  return (
    <>
      <DashboardTobbar />
      <Navbar />
      <div className="row m-0 all-profile-layout">
        <div className="col-xl-2 col-lg-3 col-md-12 ps-0 sidebar-col">
          <Sidebar />
        </div>
        <div className="col-xl-10 col-lg-9 col-md-12 px-0 profiles-col">
          <EditProfile />
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AllProfilePage;
